/**
 * 复制文本到剪贴板（兼容 http 环境）。
 * 不依赖 navigator.clipboard（仅 https/localhost 可用），
 * 统一用 textarea + execCommand，http/https 均可。
 *
 * @returns 是否复制成功
 */
export function copyText(text: string): boolean {
  if (typeof document === 'undefined') return false;
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.top = '0';
  ta.style.left = '0';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  ta.setSelectionRange(0, text.length); // iOS Safari 兼容
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {}
  document.body.removeChild(ta);
  return ok;
}
